export const days = [
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday',
];

export const pickupFrequency = [
  'Per Event',
  'Daily',
  'Weekly',
  'Bi-Weekly',
  'Monthly',
];
